import type { ProductImageType } from 'product/types/Product'

export const SUGGESTIONS_URL = `${process.env.NEXT_PUBLIC_SITE_BASE_URL}/ws-search/mango/json?scope=//catalog01`
export const LAST_VIEW_URL = `${process.env.NEXT_PUBLIC_SITE_BASE_URL}/services/garments/`

export { CommonGenericEvents, LocationParams } from './analytics/analytics'

// Results Page

export const IMAGE_ORDER: ProductImageType[] = [
	'O1',
	'F',
	'R',
	'D1',
	'D2',
	'D3',
	'D4',
	'D5',
	'D6',
	'D7',
	'D8',
	'D9',
	'B',
]

export const TWO_COLUMNS_STYLE = '50%'
export const TWO_COLUMNS_SIZE = '50vw'
export const FOUR_COLUMNS_STYLE = '25%'
export const FOUR_COLUMNS_SIZE = '25vw'
